<template>
    <div class="file-download-grp">
        <div class="file-download-area">
            <template v-for="(theFile, theIndex) in theFileList">
                <swb-file-download :class="{'last' : theIndex == theFileList.length-1 }" ref="fileDownloads" :clickable="(!autoDownload && !theFileStates[theIndex])" :fileNameHeader="fileNameHeader" :seqNo="theIndex + 1" :url="theFile.url"
                                   :post="theFile.post" :asForm="theFile.asForm" :params="theFile.params" :data="theFile.data" :fileName="theFile.fileName" :onStarted="_onFileStarted" :onResult="_onFileResult"></swb-file-download>
            </template>
        </div>
        <div v-if="summary" class="summary">
            下载文件 总数：<label class="total">{{ total }}</label> , 成功：<label class="done">{{ done }}</label> ，失败：<label class="fail">{{ fail }}</label>
            <el-checkbox v-if="xlsExport == true" style="margin-left: 20px;color:navy;" v-model="valueAsNormalFormats">按常规格式输出数据</el-checkbox>
            <slot name="extBtn"></slot>
        </div>
    </div>

</template>

<script>
    import { Utils, H5file } from '../../app.base'
    import { Vue } from '../../app.vues'
    import SwbFileDownload from './FileDownload.vue';
    //
    export default {
        components: {SwbFileDownload},
        name: 'swb-file-download-grp',
        desc: 'Ajax文件下载组',
        props: {
            fileNameHeader: {//自定义文件名Response头名称
                type: String,
                default: null
            },
            fileList: {//要下载的文件列表信息 =》 参看 FileDownload.vue
                type: Array,
                default: []
            },
            nextDelay: {//下个下载文件的延迟毫秒数
                type: Number,
                default: 1000
            },
            summary: {//是否显示汇总信息
                type: Boolean,
                default: true
            },
            xlsExport: {//是否纯xls导出（从而支持“按常规格式输出”选项）
                type: Boolean,
                default: false
            },
            onResult: {//{type : info/warn/error, message, total, done, fail}
                type: Function
            }
        },
        data() {
            return {
                //按常规格式输出xls数与值
                valueAsNormalFormats: false,
                //
                autoDownload: false,
                autoDownloadTimer: null,
                //整理过的文件列表
                theFileList: [],
                theFileStates: [],
                //文件数量
                total: 0,
                done: 0,
                fail: 0
            }
        },
        //
        mounted() {
            let self = this;
            //
            this._filterFileList();
            //下载
            let theFileList = this.theFileList;
            this.total = theFileList.length;
            if(this.total == 0) {
                let message = "要下载的文件列表为空";
                if(typeof Toast !== 'undefined') {
                    Toast.show(message, 3000, 'warning');
                }
                else {
                    console.warn(message);
                }
            }
        },
        beforeDestroy() {
            clearTimeout(this.autoDownloadTimer);
            //
            this.autoDownloadTimer = null;
            this.theFileList = null;
            this.theFileStates = null;
            //
            this.fileList = null;
            this.onResult = null;
        },
        //
        methods: {
            //开始自动下载
            startAutoDownload() {
                this.autoDownload = true;
                //
                this._downloadNextFile(true);
            },
            //停止自动下载
            stopAutoDownload() {
                this.autoDownload = false;
                clearTimeout(this.autoDownloadTimer);
            },
            _getNextSeqNo() {//获取下一个未下载的文件seqNo
                if(this.done == this.total) {
                    return 0;
                }
                let theFileStates = this.theFileStates;
                for(let i = 0, c = theFileStates.length; i < c; i++) {
                    if(!theFileStates[i]) {
                        return i + 1;
                    }
                }
                return 0;
            },
            _downloadNextFile(noDelay = false) {
                let seqNo = this._getNextSeqNo();
                if(seqNo > 0 && seqNo <= this.total) {
                    let fileDownloads = this.$refs.fileDownloads;
                    let fileDownload = fileDownloads[seqNo - 1];
                    if(noDelay) {
                        fileDownload.doDownload(this.valueAsNormalFormats);
                    }
                    else {
                        let self = this;
                        this.autoDownloadTimer = setTimeout(function () {//必须延迟才能连续下载
                            fileDownload.doDownload(self.valueAsNormalFormats);
                        }, this.nextDelay);
                    }
                }
            },
            _onResult() {
                let result = {
                    total: this.total,
                    done: this.done,
                    fail: this.fail
                };
                if(this.done == this.total) {//全部成功
                    result.type = 'info';
                    result.message = this.total + '个文件 全部下载成功';
                }
                else if(this.fail == this.total) {//全部失败
                    result.type = 'error';
                    result.message = this.total + '个文件 全部下载失败';
                }
                else {//部分成功，部分失败
                    result.type = 'warn';
                    result.message = this.done + '个文件 下载成功，' + this.fail + '个文件 下载失败';
                }
                //
                if(this.onResult) {
                    let parent = this.parent || null;
                    //
                    this.onResult.call(parent, result);
                }
                else {
                    console[result.type](result.message);
                }
            },
            _onFileStarted(seqNo) {
                this.$set(this.theFileStates, seqNo - 1, true);
            },
            _onFileResult(result) {
                let seqNo = result.seqNo;
                let message = '第 ' + seqNo + ' 个文件 ' + result.fileName + ' 下载';
                if(result.type == 'info') {
                    this.done++;
                    message += '完毕';
                }
                else {
                    this.fail++;
                    message += '失败';
                }
                console.log(message);
                if(this.done + this.fail == this.total) {
                    //已经全部下载完毕
                    this._onResult();
                    //
                    return;
                }
                //
                if(this.autoDownload) {
                    this._downloadNextFile();
                }
            },
            _filterFileList() {
                let fileList = this.fileList || [];
                let theFileList = [];
                let theFileStates = [];
                for(let i = 0, c = fileList.length; i < c; i++) {
                    let tmpFile = fileList[i];
                    let theFile = {
                        params: null,
                        fileName: null
                    };
                    if(typeof tmpFile == 'string') {
                        theFile.url = tmpFile;
                    }
                    else {
                        theFile.url = tmpFile.url;
                        if(tmpFile.params) {
                            theFile.params = tmpFile.params;
                        }
                        if(tmpFile.fileName) {
                            theFile.fileName = tmpFile.fileName;
                        }
                        theFile.post = tmpFile.post || false;
                        if(theFile.post) {
                            theFile.asForm = tmpFile.asForm || false;
                            theFile.data = tmpFile.data || {};
                        }
                        else {
                            theFile.asForm = false;
                            theFile.data = null;
                        }
                    }
                    //
                    theFileList[i] = theFile;
                    theFileStates[i] = false;
                }
                //
                this.theFileStates = theFileStates;
                this.theFileList = theFileList;
            }
        }
    }

</script>


<style>
    .file-download-grp {
        display: inline-block;
        text-align: left;
        padding: 4px;
        width: 100%;
        height: 100%;
        overflow: hidden;
    }

    .file-download-grp .file-download-area {
        height: calc(100% - 32px);
        height: -webkit-calc(100% - 32px);
        height: -moz-calc(100% - 32px);
        overflow-y: auto;
    }

    .file-download-grp .file-download {
        border-bottom-width: 0;
    }

    .file-download-grp .file-download .loadinfo {
        margin-top: 4px;
    }

    .file-download-grp .file-download.last {
        border-bottom-width: 1px;
    }

    .file-download-grp .summary {
        height: 30px;
        line-height: 18px;
        padding-top: 8px;
    }

    .file-download-grp .summary .total {
        color: navy;
    }

    .file-download-grp .summary .done {
        color: #009900;
    }

    .file-download-grp .summary .fail {
        color: #e4393c;
    }
</style>



// WEBPACK FOOTER //
// src/compo/ctrl/FileDownloadGrp.vue